import Utils from "../utils/Utils";

const getAuth = ({ jwt, Authorization } = {}) => jwt || Authorization || "";

const addParam = (params, key, value) => {
  if (value !== undefined && value !== null && value !== "") {
    params.append(key, value);
  }
};

const vendorOrderController = {
  accept: ({ Authorization, companyId, companyID, jwt, orderId, request } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId || companyID);
    addParam(params, "orderId", orderId);

    return Utils.controller(
      "api/vendor/orders/v1/accept",
      request,
      "POST",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  complete: ({ Authorization, companyId, companyID, jwt, orderId } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId || companyID);
    addParam(params, "orderId", orderId);

    return Utils.controller(
      "api/vendor/orders/v1/complete",
      "",
      "PATCH",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  counts: ({ Authorization, companyId, companyID, jwt } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId || companyID);

    return Utils.controller(
      "api/vendor/orders/v1/counts",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  dashboard: ({ Authorization, companyId, companyID, jwt } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId || companyID);

    return Utils.controller(
      "api/vendor/orders/v1/dashboard",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  list: ({
    Authorization,
    companyId,
    companyID,
    jwt,
    page,
    size,
    status,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId || companyID);
    addParam(params, "page", page);
    addParam(params, "size", size);
    addParam(params, "status", status);

    return Utils.controller(
      "api/vendor/orders/v1/list",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  reject: ({ Authorization, companyId, companyID, jwt, orderId, request } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId || companyID);
    addParam(params, "orderId", orderId);

    return Utils.controller(
      "api/vendor/orders/v1/reject",
      request,
      "POST",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },
};

export default vendorOrderController;
